import React, { useState } from 'react';

function BetResponseModal({ bet, onClose, onResponseSubmitted, currentUserEmail }) {
  const [predictionValue, setPredictionValue] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!predictionValue.trim()) {
      setError('Please enter your prediction.');
      return;
    }

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + `/bets/${bet.id}/respond`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-User-Email': currentUserEmail
          },
          credentials: 'include',
          body: JSON.stringify({ prediction_value: predictionValue }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        setSuccess('Prediction submitted successfully!');
        setTimeout(() => {
          onResponseSubmitted();
          onClose();
        }, 1500);
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Failed to submit prediction.');
      }
    } catch (err) {
      setError('Network error or server unavailable.');
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(13, 13, 13, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #3d3127 0%, #2a2018 100%)',
        padding: '30px',
        borderRadius: '4px',
        border: '2px solid #5a4a38',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.9), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        color: '#f9f6f0'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #5a4a38', paddingBottom: '15px' }}>
          <h2 style={{ margin: 0, color: '#daa520', textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)' }}>Make Your Prediction</h2>
          <button onClick={onClose} style={{
            background: 'none',
            border: 'none',
            fontSize: '32px',
            cursor: 'pointer',
            color: '#daa520',
            padding: '0',
            lineHeight: '1',
            fontWeight: 'bold'
          }}>×</button>
        </div>

        <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '3px', borderLeft: '4px solid #b8860b' }}>
          <p style={{ margin: '8px 0', color: '#f9f6f0' }}><strong style={{ color: '#daa520' }}>Bet:</strong> {bet.description}</p>
          <p style={{ margin: '8px 0', color: '#f9f6f0' }}><strong style={{ color: '#daa520' }}>Creator:</strong> {bet.creator_name}</p>
          <p style={{ margin: '8px 0', color: '#f9f6f0' }}><strong style={{ color: '#daa520' }}>Creator's Prediction:</strong> {bet.creator_prediction}</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: '#ff6b6b', marginBottom: '15px', padding: '10px', background: 'rgba(139, 46, 46, 0.3)', borderRadius: '3px', border: '1px solid #8b2e2e' }}>{error}</p>}
          {success && <p style={{ color: '#69db7c', marginBottom: '15px', padding: '10px', background: 'rgba(45, 90, 71, 0.3)', borderRadius: '3px', border: '1px solid #2d5a47' }}>{success}</p>}

          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="predictionValue" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#daa520' }}>
              Your prediction:
            </label>
            <input
              type="text"
              id="predictionValue"
              value={predictionValue}
              onChange={(e) => setPredictionValue(e.target.value)}
              placeholder="e.g., 27.3"
              style={{
                width: '100%',
                padding: '10px',
                boxSizing: 'border-box',
                fontSize: '14px',
                background: '#2d2317',
                border: '2px solid #5a4a38',
                color: '#f9f6f0',
                borderRadius: '3px'
              }}
              required
            />
          </div>

          <button type="submit" style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            background: 'linear-gradient(145deg, #b8860b, #cd7f32)',
            color: '#1a1612',
            border: '2px solid #daa520',
            borderRadius: '3px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.6)'
          }}>
            Submit Prediction
          </button>
        </form>
      </div>
    </div>
  );
}

export default BetResponseModal;
